import React, { useState } from 'react';
import './MainHeader.css';
import logo from '../../office-logo.svg';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';
import { Avatar, Button } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import LoginPopover from '../auth/LoginPopover';

const MainHeader = () => {
    const { user, logout } = useAuth();
    const [loginAnchorEl, setLoginAnchorEl] = useState<HTMLElement | null>(null);
    // There is no per-user profile picture in this product yet (that lived on the parent's
    // employee-documents feature, carved out along with the rest of HR). Every signed-in user
    // gets the default avatar icon until a POS-appropriate profile-photo feature is designed.
    const profileImageUrl: string | null = null;

    return (
        <header className="main-header">
            <div className="logo-container">
                <img src={logo} alt="Logo" className="logo-image" />
            </div>

            {user ? (
                <div className="profile-section">
                    <span className="username-display">{user.name}</span>
                    <Link to="/profile" className="profile-link">
                        <Avatar
                            src={profileImageUrl ?? undefined}
                            sx={{ width: 28, height: 28 }}
                        >
                            {!profileImageUrl && <PersonIcon sx={{ fontSize: 18 }} />}
                        </Avatar>
                        My Profile
                    </Link>
                    <button onClick={logout} className="logout-button">
                        Logout
                    </button>
                </div>
            ) : (
                <div className="profile-section">
                    <Button
                        variant="contained"
                        onClick={(e) => setLoginAnchorEl(e.currentTarget)}
                        sx={{
                            backgroundColor: '#007bff',
                            '&:hover': { backgroundColor: '#0056b3' },
                            textTransform: 'none',
                        }}
                    >
                        Login
                    </Button>
                    <LoginPopover
                        anchorEl={loginAnchorEl}
                        open={Boolean(loginAnchorEl)}
                        onClose={() => setLoginAnchorEl(null)}
                    />
                </div>
            )}
        </header>
    );
};

export default MainHeader;
